import Portfolio from './portfolio';
import User from './user';
import LoadingView from './loading-view';
import LoadingViewPublic from './loading-view-public';
import RootView from './root';
import RsaRedirect from './rsa-redirect';
import Maturities from './maturities';
import Reports from './reports';
import Downloads from './downloads';
import Settings from './profile';
import Payments from './payments';
import Insights from './cio-insights';
import DocSignCenter from './doc-sign-center';
import Docsign from './docsign';
import Chat from './chat';
import TradeLibrary from './trade-library';
import PortfolioRedirect from './portfolio-redirect';
import ChangePassword from './change-password';

export default {
  Portfolio,
  Settings,
  Maturities,
  User,
  LoadingView,
  LoadingViewPublic,
  RootView,
  RsaRedirect,
  Reports,
  Downloads,
  Payments,
  Insights,
  DocSignCenter,
  Docsign,
  Chat,
  TradeLibrary,
  PortfolioRedirect,
  ChangePassword
};
